<template>
  <v-img v-bind="$attrs" @loadstart="reset" @error="error">
    <template>
      <slot />
    </template>
    <template v-slot:placeholder>
      <v-row
          class="fill-height ma-0"
          :class="{ 'gray lighten-3' : !$attrs.src }"
          align="center"
          justify="center"
      >
        <v-icon v-if="fail || !$attrs.src">mdi-image-off</v-icon>
        <v-progress-circular
            v-else
            indeterminate
            color="primary"
        />
      </v-row>
    </template>
  </v-img>
</template>

<script>
export default {
  name: 'LoadImage',
  data: () => ({
    fail: null
  }),
  methods: {
    reset () {
      this.fail = null
    },
    error () {
      this.fail = true
    }
  }
}
</script>
